<!--
 * @  邮箱
-->
<template>
  <el-form-item :label="label" :prop="prop" :rules="rules" :size="size">
    <el-input v-model="id" :placeholder="$t('inputText')" :clearable="clearable" maxlength="68" />
  </el-form-item>
</template>
<script>
import { patternEmail } from '@/utils/validate';
export default {
  name: 'BjFormItemEmail',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'mini',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: [String, Number],
      default: '邮箱',
    },
    prop: {
      type: [String],
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
    };
  },
  computed: {
    rules() {
      return [
        {
          validator: this.validatorEmail,
          required: this.required,
          trigger: 'blur',
        },
      ];
    },
  },
  watch: {
    value: {
      handler(v) {
        this.id = v;
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
    },
  },
  methods: {
    validatorEmail(rule, value, callback) {
      if (typeof value == 'number') value = String(value);
      if (!value) {
        if (rule.required) {
          callback(new Error(this.$t('PleaseEmailAddressText')));
        } else {
          callback();
        }
      } else {
        if (!patternEmail.test(String(value))) {
          callback(new Error(this.$t('MailboxFormatText')));
        } else {
          callback();
        }
      }
    },
    // 限制整数输入
    proving(e) {
      // 禁止负数和小数点
      e.target.value = e.target.value.replace(/\D/g, '');
    },
  },
};
</script>
